module.exports = __webpack_public_path__ + "static/media/sale2.c77cb5cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/sale2.png
// module id = 554
// module chunks = 0